var SwiperCitations = {
    init:function(){
        var swiper = new Swiper(".akrolab-slider-citations .swiper-container", {
            slidesPerView:'auto',
            spaceBetween: 45,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
          });
    }
}

$(window).load(function(){
    if($('.akrolab-slider-citations').length){
        SwiperCitations.init();
    }
})